import {SET_DB_ADAPTER, SET_AUTH_ADAPTER} from '../../constants';

const initialState = {
  authentication: null,
  db: null
};

export default function adapters(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_ADAPTER:
      return {
        ...state,
        authentication: action.adapter
      }
    case SET_DB_ADAPTER:
      return {
        ...state,
        db: action.adapter
      }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/store/reducers/adapters.js
 **/